import Pagination from '@/components/pagination/index.vue';
import Service from '../org-service';
import DictService from '../../service/service-service';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      cropList: [],
      serviceScore: [],
      serviceArea: [],
      serviceProject: [],
      serviceRegion: [],
      categoryList: [{
        name: '托管服务',
        type: '001'
      }, {
        name: '农机服务',
        type: '003'
      }, {
        name: '飞防服务',
        type: '002'
      }],
      total: 0,
      queryName: {},
      query: {
        skip: 0,
        category: '',
        limit: 10,
        crop: '',
        scoreLevel: '',
        areaLevel: '',
        sortBy: '',
        areaCode: ''
      },
      activeType: '',
      list: [],
      tId: '66aaf784247b9fffdb5eba0b',
      name: ''
    };
  },

  created() {
    this.name=this.$route.query.name,
    console.log(this.name);
    // console.log(999, this.$route.query);
    this.activeType = this.$route.query.type || 'all';
    // console.log(this.activeType, '111');
    this.resetQuery();
    this.getTypeList();
  },

  watch: {
    $route(newRoute) {
      if (newRoute) {
        this.activeType = newRoute.query.type;
        this.resetQuery();
        this.getTypeList();
      }
    }
  },
  methods: {
    getRegionDisplay(regionList) {
      // console.log(regionList);
      if (!regionList.length) return '';
      const arr = regionList.map(item => {
        // 确保 item.area 存在并替换
        if (item.area && typeof item.area === 'string') {
          return item.area.replace(/广西壮族自治区百色市/g, '');
        }
        return item.area;  // 如果没有匹配，直接返回原始值
      });
      return arr.join('，');
    },

    getList(page) {
      if (page) {
        this.query.skip = (page.pageNo - 1) * 10;
        this.query.limit = 10;
      } else {
        this.query.skip = '0';
      }
      const obj = {};
      Object.keys(this.query).forEach(item => {
        if (this.query[item] && (this.query[item] !== 'all')) {
          obj[item] = this.query[item];
        }
      });
      this.getTableList(obj);
    },

    getTableList(obj) {
      Service.getPartnerList1({ tId: this.tId, ...obj }).then(res => {
        this.list = res.result;
        this.total = res.total;
      });
    },

    resetQuery() {
      this.query = {
        skip: 0,
        limit: 10,
        crop: '',
        scoreLevel: '',
        areaLevel: '',
        sortBy: '',
        category: '',
        areaCode: ''
      };
      if (this.activeType !== 'all') {
        this.query.category = this.activeType;
      }
      this.queryName = {};
      this.getList();
    },

    delquery(key, value) {
      this.query[value] = '';
      this.queryName[value] = '';
      this.getList();
    },

    getTypeList() {
      if (this.activeType !== 'all') {
        DictService.getServiceCategoryList({ tId: this.tId, code: this.activeType }).then(res => {
          this.serviceProject = res;
        });
      }
      DictService.getServiceScoreLevelList().then(res => {
        this.serviceScore = res;
      });
      DictService.getServiceAreaLevelList().then(res => {
        this.serviceArea = res;
      });
      DictService.getAreaList({ current: '451022', level: 3 }).then(res => {
        const result = res.result.filter(item => item.id && item.id !== '150721402');
        this.serviceRegion = result;
      });
    },

    updateQueryParmas(type, item) {
      console.log(type, item);
      this.query[type] = item.type || item.id || item._id;
      this.queryName[type] = item.name;
      this.getList();
    },

    getTableListBySort(type) {
      if (this.query.sortBy !== type) {
        this.query.sort = 1;
      } else {
        this.query.sort = this.query.sort === 1 ? -1 : 1;
      }
      this.query.sortBy = type;
      this.getList();
    },

    toDetail(id) {
      // console.log(id, '11');
      // console.log(this.activeType, '22');
      if (this.activeType === '003') {
        this.$router.push('/socialized-service/partner/partner-detail1?id=' + id + '&type=' + this.activeType + '&sid=' + this.$route.query.id);
      } else {
        this.$router.push('/socialized-service/partner/partner-detail2?id=' + id + '&type=' + this.activeType + '&sid=' + this.$route.query.id);
      }

    },
    toOther(url) {
      // console.log(url);
      this.$router.push(url);
    }
  }
};
